module.exports = __webpack_public_path__ + "static/don10-398f4ae50300cfe93e3026a354ad09e4.jpg";